export module AsortedConstants {
  export const FAST_FORWARDING_SPEED = 2;
}
